import React, { useState, useEffect } from 'react';
import {
  TextField, Button, Grid, Typography, Paper, FormControlLabel, Switch,
  MenuItem
} from '@material-ui/core';
import api from './api';
import { toast } from 'react-toastify';

const Site = ({ siteData, refetch ,memberID,countryData}) => {
  const s3_site_url = 'https://d6-halo.s3.us-east-2.amazonaws.com/static/media/logo/';

  const [formData, setFormData] = useState({
    username: siteData?.username || '',
    image: siteData?.imageN || null,
    siteName: siteData?.siteName || '',
     metaTitle: siteData?.metaTitle || '', metaDescription: siteData?.metaDescription || '', metaKeywords: siteData?.metaKeywords || '',
    live: siteData?.live || false,
    currency: siteData?.currency || false,

  });

  const [imagePreview, setImagePreview] = useState(
    siteData?.imageN ? s3_site_url + siteData.imageN : null
  );

  const [processing, setProcessing] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, files, checked } = e.target;

    if (type === 'file') {
      const file = files[0];
      setFormData(prev => ({ ...prev, [name]: file }));
      setImagePreview(file ? URL.createObjectURL(file) : null);
    } else if (type === 'checkbox') {
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async () => {


    const requiredFields = ['username', 'siteName', 'metaTitle', 'metaDescription', 'metaKeywords','currency'];
  const missingFields = requiredFields.filter(field => !formData[field]?.trim());

  if (missingFields.length > 0) {
    toast.error(`Please fill out all required fields: ${missingFields.join(', ')}`);
    return;
  }

  
  if (!siteData?.ID && (!formData.image || !formData.image.name)) {
    toast.error('Please upload an image.');
    return;
  }
    const data = new FormData();
    data.append('username', formData.username);
    data.append('image', formData.image&&formData.image.name?formData.image:'');
    data.append('siteName', formData.siteName);
        data.append('metaTitle', formData.metaTitle);
    data.append('metaDescription', formData.metaDescription);
    data.append('metaKeywords', formData.metaKeywords);
    data.append('currency', formData.currency);

    data.append('live', formData.live);
 if (!siteData?.ID) {
    // Create flow
    data.append('memberID', memberID); // Only needed on create
  } else {
    data.append('id', siteData.ID); // ID required for PUT
  }
    setProcessing(true);
    try {
       const res = siteData?.ID
      ? await api.put('site-v2', data)
      : await api.post('site-v2', data);

    toast.success(siteData?.ID ? 'Site updated' : 'Site created: ' + res.data.site_id);
      refetch?.();
    } catch (err) {
      console.error(err);
      toast.error('Failed to create site');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Paper style={{ padding: 20 }}>
      <Typography variant="h6">{siteData ? 'Edit Site' : 'Create Site'}</Typography>

      <Grid container spacing={2}>
        {['username', 'siteName','metaTitle','metaDescription','metaKeywords'].map((field) => (
          <Grid item xs={12} sm={6} key={field}>
            <TextField
              fullWidth
              required
              label={field}
              name={field}
              value={formData[field]}
              
              onChange={handleChange}
            />
          </Grid>
        ))}
 <Grid item xs={12} sm={6}>
      <TextField
        select
        fullWidth
        required
        label="Select Currency Country"
        name="currency"
        value={formData.currency} // assuming item has a 'currency' field
        onChange={(e) => handleChange(e)}
      >
        {countryData?.map((currency) => (
          <MenuItem key={currency.ID} value={currency.name}>
            {currency.name}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
        <Grid item xs={12} sm={6}>
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleChange}
            style={{ marginTop: 16 }}
          />
        </Grid>

        {(imagePreview || (typeof formData.image === 'string' && formData.image)) && (
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">Logo Preview:</Typography>
            <img
              src={imagePreview || (s3_site_url + formData.image)}
              alt="Logo Preview"
              style={{ width: 150, height: 'auto', borderRadius: 8 }}
            />
          </Grid>
        )}

        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Switch
                checked={formData.live}
                onChange={handleChange}
                name="live"
                color="primary"
              />
            }
            label="Live"
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            variant="contained"
            disabled={processing}
            color="primary"
            onClick={handleSubmit}
          >
            {processing ? 'Saving...' : siteData ? 'Update Site' : 'Create Site'}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Site;
